import { NotifyOff } from 'education-icons';
import { Button, Link, SimpleCallback, SimpleText, useMe } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { useLessonViewParams } from 'common.components/lesson-view.index/hooks/use-lesson-view-params';
import { subscriptionModalActions } from 'common.components/lesson-view.subscription-modal/actions';
import { SUBSCRIPTION_MODAL_MODE } from 'common.components/lesson-view.subscription-modal/typings';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    onUnsubscribe: SimpleCallback;
}

export const SidePanelControlsTypeUnsubscribe = React.memo((props: Props) => {
    const { notifyCanBeRender, notifyCanNotBeRender, onUnsubscribe } = props;
    const dispatch = useDispatch();
    const { classId, subject } = useLessonViewParams();
    const me = useMe();
    const courseId = useSelector(getCurrentYearCourseId);
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const lessonId = useSelector(lessonSelectors.getLessonId);
    const activeSubscriptionSlug = useSelector((store) => {
        return lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId });
    });

    if (!activeSubscriptionSlug) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    const unsubscribe = () => {
        onUnsubscribe();
        dispatch(
            subscriptionModalActions.toggleSubscriptionModal({
                opened: true,
                mode: SUBSCRIPTION_MODAL_MODE.UNSUBSCRIBE,
            })
        );

        ym('reachGoal', 'lesson_menu_cancel_subscription', {
            teacher_id: me?.id,
            team_id: classId,
            subject: subject,
            lesson_id: lessonId,
            cl_id: clessonId,
            subcription_slug: activeSubscriptionSlug,
        });
    };

    return (
        <Link mix="qa_unsubscribe" onClick={unsubscribe} pseudo>
            <Button accent={Button.ACCENT.NORMAL} icon={<NotifyOff />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonModal.header.unsubscribe" />
            </Button>
        </Link>
    );
});
